import { Route, Routes } from 'react-router-dom';
import DashboardLayout from '@/layouts/dashboard';
import AuthGuard from '@/guards/AuthGuard';

import { PATH_PROVIDER_MANAGEMENT } from './paths';
import { ProviderCreateEdit, ProviderList } from '../pages';
import RoleBasedGuard from '@/guards/RoleBasedGuard';

const PROVIDER_ROUTES = [
  {
    path: '',
    roles: ['providers.view'],
    component: <ProviderList />,
    index: true,
  },
  {
    path: PATH_PROVIDER_MANAGEMENT.new,
    roles: ['providers.create'],
    component: <ProviderCreateEdit />,
    index: false,
  },
  {
    path: PATH_PROVIDER_MANAGEMENT.edit,
    roles: ['providers.update'],
    component: <ProviderCreateEdit />,
    index: false,
  },
];

export const ProviderRoutes = () => (
  <Routes>
    <Route
      element={
        <AuthGuard>
          <DashboardLayout />
        </AuthGuard>
      }
    >
      {PROVIDER_ROUTES.map((route, index) => (
        <Route
          key={index}
          path={route.path}
          index={route.index}
          element={
            <RoleBasedGuard roles={route.roles}>
              {route.component}
            </RoleBasedGuard>
          }
        />
      ))}
    </Route>
  </Routes>
);
